module.exports = __webpack_public_path__ + "img/logo.54fade9f.png";